// src/hooks/useActiveSection.js
import { useEffect, useState } from "react";

export default function useActiveSection(ids = []) {
  const [active, setActive] = useState("");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.find((e) => e.isIntersecting);
        if (visible) {
             
          setActive(visible.target.id);
        }
      },
      { threshold: 0.5 } 
    );

    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [ids]);

  return active;
}
